import {
    MainFilterSelectedValuesIdsAdditionalKeyEnum,
    MainFilterSelectedValuesIdsKeyEnum,
    SuggestionApiFieldNameEnum,
} from './main-filter-api-type';
import {MainFilterFieldNameEnum} from './main-filter-type';

export const fieldNameToValueIdsKeyMap: Record<
    MainFilterFieldNameEnum,
    MainFilterSelectedValuesIdsKeyEnum | MainFilterSelectedValuesIdsAdditionalKeyEnum
> = {
    [MainFilterFieldNameEnum.GROUPS]: MainFilterSelectedValuesIdsKeyEnum.GROUPS,
    [MainFilterFieldNameEnum.GROUPS_LOGICAL_OPERATION]: MainFilterSelectedValuesIdsKeyEnum.GROUPS_LOGICAL_OPERATION,
    [MainFilterFieldNameEnum.BRANDS]: MainFilterSelectedValuesIdsKeyEnum.BRANDS,
    [MainFilterFieldNameEnum.COUNTRIES]: MainFilterSelectedValuesIdsKeyEnum.COUNTRIES,
    [MainFilterFieldNameEnum.REGIONS]: MainFilterSelectedValuesIdsKeyEnum.REGIONS,
    [MainFilterFieldNameEnum.CITIES]: MainFilterSelectedValuesIdsKeyEnum.CITIES,
    [MainFilterFieldNameEnum.STREETS]: MainFilterSelectedValuesIdsKeyEnum.STREETS,
    [MainFilterFieldNameEnum.NAMES]: MainFilterSelectedValuesIdsKeyEnum.NAMES,
    [MainFilterFieldNameEnum.CODES]: MainFilterSelectedValuesIdsKeyEnum.CODES,
    [MainFilterFieldNameEnum.CLOSED]: MainFilterSelectedValuesIdsAdditionalKeyEnum.CLOSED,
    [MainFilterFieldNameEnum.ACTIVE]: MainFilterSelectedValuesIdsAdditionalKeyEnum.ACTIVE,
    [MainFilterFieldNameEnum.IS_PRIORITY_PLACEMENT]: MainFilterSelectedValuesIdsKeyEnum.PRIORITY_PLACEMENT,
    [MainFilterFieldNameEnum.IS_PAID]: MainFilterSelectedValuesIdsKeyEnum.IS_PAID,
    [MainFilterFieldNameEnum.NEED_MODERATE]: MainFilterSelectedValuesIdsKeyEnum.NEED_MODERATE,
};

export const fieldNameToSuggestionsFieldKey: Record<MainFilterFieldNameEnum, SuggestionApiFieldNameEnum> = {
    [MainFilterFieldNameEnum.GROUPS]: SuggestionApiFieldNameEnum.GROUPS,
    [MainFilterFieldNameEnum.GROUPS_LOGICAL_OPERATION]: SuggestionApiFieldNameEnum.GROUPS_LOGICAL_OPERATION,
    [MainFilterFieldNameEnum.BRANDS]: SuggestionApiFieldNameEnum.BRANDS,
    [MainFilterFieldNameEnum.COUNTRIES]: SuggestionApiFieldNameEnum.COUNTRIES,
    [MainFilterFieldNameEnum.REGIONS]: SuggestionApiFieldNameEnum.REGIONS,
    [MainFilterFieldNameEnum.CITIES]: SuggestionApiFieldNameEnum.CITIES,
    [MainFilterFieldNameEnum.STREETS]: SuggestionApiFieldNameEnum.STREETS,
    [MainFilterFieldNameEnum.NAMES]: SuggestionApiFieldNameEnum.NAMES,
    [MainFilterFieldNameEnum.CODES]: SuggestionApiFieldNameEnum.CODES,
    [MainFilterFieldNameEnum.CLOSED]: SuggestionApiFieldNameEnum.CLOSED,
    [MainFilterFieldNameEnum.ACTIVE]: SuggestionApiFieldNameEnum.ACTIVE,
    [MainFilterFieldNameEnum.IS_PRIORITY_PLACEMENT]: SuggestionApiFieldNameEnum.PRIORITY_PLACEMENT,
    [MainFilterFieldNameEnum.IS_PAID]: SuggestionApiFieldNameEnum.IS_PAID,
    [MainFilterFieldNameEnum.NEED_MODERATE]: SuggestionApiFieldNameEnum.NEED_MODERATE,
};

export const suggestionsPerRequestsCount = 10;
